/**
 *
 */
import {Fancybox} from "@fancyapps/ui";


/**
 * add lightbox functionality to all gallery thumbnails
 *
 * @see https://fancyapps.com/docs/ui/fancybox/api
 * @see https://fancyapps.com/docs/ui/fancybox/options
 */
const setupCommunityGalleries = () =>
{
	const galleryThumbs = document.querySelectorAll( '[data-gallery-thumb]' );

	galleryThumbs.forEach( thumb =>
	{
		const captions = [];

		thumb.addEventListener( 'click', e =>
		{
			//const galleryTitle = thumb.dataset.galleryTitle;
			const galleryId    = thumb.dataset.galleryThumb;
			const galleryLinks = document.querySelectorAll( '[data-gallery-images="' + galleryId + '"] a' );
			const galleryItems = [];

			galleryLinks.forEach( anchor =>
			{
				const title = anchor.getAttribute( 'title' ).trim();

				galleryItems.push( {
					src:  anchor.getAttribute( 'href' ),
					type: 'image',
				} );

				captions.push( title );
			} );

			new Fancybox( galleryItems, {
				mainClass: 'gallery-lightbox',
				caption:   ( fb, opts, image ) => captions[image.index],
			} );

			e.preventDefault();
			e.stopPropagation();
		} );
	} );
};


/**
 *
 */
export default setupCommunityGalleries;